const sendGTMEvent = (eventObject, eventType) => {
  // based on the eventType, send the appropriate event
  // to Google Tag Manager
  const eventTypeEventNameMap = {
    add: 'ecommerce.add',
    remove: 'ecommerce.remove',
    begin_checkout: 'ecommerce.begin_checkout',
    add_payment_info: 'ecommerce.add_payment_info',
    purchase: 'ecommerce.purchase',
  };
  // default is add
  const eventName = eventTypeEventNameMap[eventType] || 'ecommerce.add';
  const eventAddons = {
    v: 11, // seer version
    currency_code: 'USD',
  };
  const gtmEventObject = {
    event: eventName,
  };
  gtmEventObject[eventName] = { ...eventObject, ...eventAddons };
  if (window.pushGTMEvent) {
    window.pushGTMEvent(gtmEventObject);
  }
};

export default sendGTMEvent;
